import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const eur = (n) => new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(n || 0);
const Delta = ({ v }) => (v == null ? <span className="text-slate-400">—</span> : <span className={v >= 0 ? "text-emerald-600" : "text-red-600"}>{v > 0 ? "+" : ""}{v}%</span>);

function Table({ title, rows, showMargin, testid }) {
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-5 min-w-0" data-testid={testid}>
      <h3 className="font-heading text-base font-semibold text-slate-900 mb-3">{title}</h3>
      {rows.length ? rows.map((r) => (
        <div key={r.key} className="text-sm py-1.5 border-b border-slate-100 last:border-0" data-testid={`${testid}-row`}>
          <div className="flex justify-between gap-2"><span className="text-slate-700 break-words min-w-0">{r.name}</span><span className="shrink-0 font-medium">{eur(r.revenue)}</span></div>
          <div className="text-[11px] text-slate-400">{r.count} RDV · panier {eur(r.avg_basket)} · {Math.round((r.hours || 0) * 10) / 10} h{showMargin ? ` · marge ${eur(r.margin)}` : ""}</div>
        </div>
      )) : <p className="text-sm text-slate-500">Aucune donnée sur la période.</p>}
    </div>
  );
}

export default function AdvancedStats({ start, end }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/analytics/advanced", { params: { start, end } }).then((r) => setD(r.data)).catch(() => setD(null)); }, [start, end]);
  if (!d) return null;
  const K = ({ label, cur, prev, delta, money = true }) => (
    <div className="bg-white border border-slate-200 rounded-xl p-4"><div className="text-xs text-slate-400">{label}</div>
      <div className="text-xl font-bold mt-1 text-slate-900">{money ? eur(cur) : cur}</div>
      <div className="text-[11px] text-slate-500">Période préc. {money ? eur(prev) : prev} · <Delta v={delta} /></div></div>
  );
  return (
    <div className="space-y-4" data-testid="analytics-advanced">
      <h3 className="font-heading text-base font-semibold text-slate-900">Comparaison avec la période précédente ({new Date(d.previous_period.start).toLocaleDateString("fr-FR")} → {new Date(d.previous_period.end).toLocaleDateString("fr-FR")})</h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <K label="CA des rendez-vous" cur={d.current.revenue} prev={d.previous.revenue} delta={d.delta_pct.revenue} />
        <K label="Nombre de RDV" cur={d.current.count} prev={d.previous.count} delta={d.delta_pct.count} money={false} />
        <K label="Panier moyen" cur={d.current.avg_basket} prev={d.previous.avg_basket} delta={d.previous.avg_basket ? Math.round((d.current.avg_basket - d.previous.avg_basket) / d.previous.avg_basket * 1000) / 10 : null} />
        {d.show_margin && <K label="Marge estimée" cur={d.current.margin} prev={d.previous.margin} delta={d.delta_pct.margin} />}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Table title="Par collaborateur" rows={d.by_assignee} showMargin={d.show_margin} testid="analytics-by-assignee" />
        <Table title="Par type de véhicule" rows={d.by_vehicle_type} showMargin={d.show_margin} testid="analytics-by-vehicle" />
      </div>
    </div>
  );
}
